import axios from "axios";
import { BASE_URL, API_GATEWAY_URL } from "../environment";

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

export const apiGatewayClient = axios.create({
  baseURL: API_GATEWAY_URL,
});
